import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { RefreshCw, X } from 'lucide-react';

export function PWAUpdatePrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  
  // Avoid registering Service Worker in development (can break Vite dynamic imports)
  const isDev = import.meta.env.DEV;

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (!isDev) console.log('SW Registered: ' + r);
    },
    onRegisterError(error) {
      if (!isDev) console.log('SW registration error', error);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      setShowPrompt(true);
    }
  }, [needRefresh]);

  const handleUpdate = () => {
    updateServiceWorker(true);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    setNeedRefresh(false);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 md:left-auto md:right-4 md:w-96">
      <Card className="p-4 shadow-lg border-primary">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <h3 className="font-semibold mb-1">업데이트 사용 가능</h3>
            <p className="text-sm text-muted-foreground mb-3">
              새로운 버전의 Gemurhood를 사용할 수 있습니다
            </p>
            <div className="flex gap-2">
              <Button onClick={handleUpdate} size="sm" className="flex-1">
                <RefreshCw size={16} className="mr-2" />
                업데이트
              </Button>
              <Button onClick={handleDismiss} variant="outline" size="sm">
                <X size={16} />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}